import reportServices from '@/api/report/reportServices'

export default {
  listagemRelatorios({ commit }, id) {
    return reportServices
      .listagemRelatorios(id)
      .then((result) => result)
      .catch((error) => error)
  },
  printReport({ commit }, report) {
    return reportServices.printReport(report)
  },
  getReport({ commit }) {
    return reportServices
      .getReport()
      .then((result) => result)
      .catch((error) => error)
  },
  listagemGeral({ commit }, pageConfig) {
    if (pageConfig.module === 'administrative') {
      pageConfig.module = 'administrativo'
    } else if (pageConfig.module === 'financial') {
      pageConfig.module = 'financeiro'
    } else if (pageConfig.module === 'attendance') {
      pageConfig.module = 'atendimento'
    } else if (pageConfig.module === 'reportPageProtocol') {
      pageConfig.module = 'protocolo'
    }
    return reportServices
      .listagemGeral(pageConfig)
      .then((result) => result)
      .catch((error) => error)
  },
  printReportReceita({ commit }, report) {
    return reportServices.printReportReceita(report)
  },
  printReportExame({ commit }, report) {
    return reportServices.printReportExame(report)
  },
  printReportEmprestimo({ commit }, report) {
    return reportServices.printReportEmprestimo(report)
  },
  printReportAmortizacao({ commit }, report) {
    return reportServices.printReportAmortizacao(report)
  },
  printReportDre({ commit }, report) {
    return reportServices.printReportDre(report)
  },
  printReportRazaoLivro({ commit }, report) {
    return reportServices.printReportRazaoLivro(report)
  },
  printReportRazaoAnalitico({ commit }, report) {
    return reportServices.printReportRazaoAnalitico(report)
  },
  printReportRazaoHierarquico({ commit }, report) {
    return reportServices.printReportRazaoHierarquico(report)
  },
  printReportAuditoria({ commit }, report) {
    return reportServices.printReportAuditoria(report)
  },
}
